import { Controller } from "stimulus"
import { formatMoney, formatMoneyMillis, formatWeight } from 'formatters';
import { setupCountryCascade, setupCascade } from 'locations';
import { Settings } from 'settings.js.erb';

export default class extends Controller {
  static get targets() {
    return ['subjectId', 'subjectName', 'subjectIsOpo', 'genericAddressTemplate', 'totalGrossWeight',
            'mrGrossWeight', 'mrMeltedWeight', 'mrMeltingDecrease', 'mrGoldShare', 'mrGoldNetWeight',
            'mrSilverShare', 'mrSilverNetWeight', 'mrOtherShare', 'mrOtherNetWeight',
            'pricePerGram', 'totalAmount', 'sourceValue', 'insuredValue'];
  } 

  showSubjectData(event) {
    let idField = $(this.subjectIdTarget);
    let subjectOption = idField.find("option:selected");
    
    if (subjectOption.data('name')) {
      $(this.subjectNameTarget).html(subjectOption.data('name'));
      if (subjectOption.data('isOpo')) {
        $(this.subjectIsOpoTarget).html('Si');      
      } else {
        $(this.subjectIsOpoTarget).html('No');      
      }      
    } else {
      $(this.subjectNameTarget).html('');
      $(this.subjectIsOpoTarget).html('');      
    }
  }
  
  updateMeltingResult(event) {
    let totalGrossWeight = +$(this.totalGrossWeightTarget).val();
    let mrMeltedWeight = +$(this.mrMeltedWeightTarget).val();
    let mrGoldShare = +$(this.mrGoldShareTarget).val();
    let mrSilverShare = +$(this.mrSilverShareTarget).val();
    let mrOtherShare = +$(this.mrOtherShareTarget).val();

    if (totalGrossWeight && this.hasMrGrossWeightTarget) {
      $(this.mrGrossWeightTarget).val(totalGrossWeight);
    }
    if (totalGrossWeight && mrMeltedWeight) {
      $(this.mrMeltingDecreaseTarget).val(totalGrossWeight-mrMeltedWeight);
    }
    if (mrMeltedWeight && mrGoldShare) {
      $(this.mrGoldNetWeightTarget).val(mrMeltedWeight*mrGoldShare/1000);
    } else {
      $(this.mrGoldNetWeightTarget).val('');
    }
    if (mrMeltedWeight && mrSilverShare) {
      $(this.mrSilverNetWeightTarget).val(mrMeltedWeight*mrSilverShare/1000);
    } else {
      $(this.mrSilverNetWeightTarget).val('');
    }
    if (mrMeltedWeight && mrOtherShare) {
      $(this.mrOtherNetWeightTarget).val(mrMeltedWeight*mrOtherShare/1000);
    } else {
      $(this.mmrOtherNetWeightTarget).val('');
    }
  }
  updatePricePerGram(event) {
    let totalGrossWeight = +$(this.totalGrossWeightTarget).val();
    let totalAmount = +$(this.totalAmountTarget).val();
    if (totalGrossWeight > 0 && totalAmount > 0) {
      $(this.pricePerGramTarget).html(formatMoney(totalAmount/totalGrossWeight)+'/gr');      
    } else {
      $(this.pricePerGramTarget).html('');
    }
  }
  updateInsuredValue(event){
    let sourceValue = +$(this.sourceValueTarget).val();
    if (sourceValue > 0) {
      $(this.insuredValueTarget).html(formatMoney(sourceValue*Settings.insured_value_multiplier));
    } else {
      $(this.insuredValueTarget).html('');
    }    
  }
}
